import 'idempotent-babel-polyfill';
import Vue from 'vue';
window.Vue = Vue;
// const components = require.context('./Vendors/components', true, /\.vue$/i);
// components.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], components(key).default));
import App from './components/AppStickyContractor.vue';

window.addEventListener('load', () => {
    const id = '#StickyContractor';
    if (jQuery(id).length == 0) {
        console.log(id, 'not found');
        return;
    }
    const app = new Vue({
        render: h => h(App),
    });
    app.$mount(id);
});

jQuery(function ($) {
    "use strict"


    handleFixedMenu()
    $(window).resize(function(){
        handleFixedMenu()
    })
    

    $('.menu-item-has-children > a, .header__right .nav__products > a, .nav__products .side-menu a').not('.external').on('click', function(e){
        e.preventDefault()
        $(this).addClass('no-follow')
    })

    $('.menu-item-2342 a, .menu-item-2341 a').on('click', function(e){
        $(this).attr('target', '_blank')
    })

    
    // FAQ
    $('.faq__menu .topic__name, .faq__list .topic__name').on('click', function (e) {
        $(this).parent().toggleClass('open');
    })

    $('.faq__list .faq__title').on('click', function (e) {
        $(this).parent().toggleClass('open');
    });

    $('.faq__menu .topic > ul a').on('click', function(e){
        e.preventDefault()
        $('.faq__list .open').removeClass('open');

        let topicCat = $(this).attr('data-target-topic-cat')
        let topic = $(this).attr('data-target-topic')


        $('.faq__list [data-topic-cat="' + topicCat + '"]').addClass('open')
        $('.faq__list [data-topic="' + topic + '"]').addClass('open')
        
        $("html, body").animate({ scrollTop: $('.faq__list [data-topic="' + topic + '"]').offset().top - 30 });
    });





    webfitters.smoothScrollAll();

    webfitters.menuDropdown('.header__inner li.menu-item-has-children');
    mobileMenuSetup('#mobile__menu', '#mobile__menu--button', '#mobile__menu--screen');    

    webfitters.menuDropdown('.menu-contractor-navigation-container li.menu-item-has-children');
    mobileMenuSetup('#top-mobile-menu', '#top-mobile__menu--button', '#top-mobile__menu--screen');    


    if ($('.hero__slider').length) {
        $('.hero__slider').slick({
            slidesToShow: 1,
            fade: true,
            autoplay: true,
            autoplaySpeed: window.wf_general_hero_settings.autoplaySpeed ?? 5000,
            speed: 1000,
            dots: true,
            appendDots: $('.hero__pagination')
        });
    }

    if ($('.testimonial__slider').length) {
        $('.testimonial__slider').slick({
            slidesToShow: 1,
            dots: true,
            mobileFirst: true,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 1260,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });
    }

    if ($('.callouts__inner').length) {
        $('.callouts__inner').slick({
            slidesToShow: 1,
            dots: true,
            arrows: false,
            centerMode: true,
            mobileFirst: true,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 630,
                    settings: {
                        slidesToShow: 2,
                        centerMode: false
                    }
                },
                {
                    breakpoint: 1080,
                    settings: {
                        slidesToShow: 3,
                        centerMode: false
                    }
                },
                {
                    breakpoint: 1260,
                    settings: 'unslick'
                }
            ]
        });
    }

    if ($('.blog__feed').length) {
        $('.blog__feed').slick({
            slidesToShow: 1,
            dots: true,
            arrows: false,
            centerMode: true,
            mobileFirst: true,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 630,
                    settings: {
                        slidesToShow: 2,
                        centerMode: false
                    }
                },
                {
                    breakpoint: 1080,
                    settings: 'unslick'
                }
            ]
        });
    }

    if ($('.vert__slider').length) {
        $('.vert__slider').slick({
            slidesToShow: 1,
            vertical: true,
            mobileFirst: true,
            centerMode: true,
            draggable: true,
            touchThreshold: 10,
            swipeToSlide: true,
            // autoplay: true,
            // autoplaySpeed: 5000,
            // speed: 1000,
        });

        $('.slide__title h3').on('click', function () {
            var index = $(this).data('index');

            $('.vert__slider').slick('slickGoTo', index);
        });
    }

    if ($('.timeline__slider').length) {
        $('.timeline__slider').slick({
            slidesToShow: 1,
            dots: true,
            mobileFirst: true,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 830,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 1585,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ]
        });
    }

    if ($('.member__slider').length) {
        $('.member__slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            dots: true,
            mobileFirst: true,
            autoplay: false,
            autoplaySpeed: 5000,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 630,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        centerMode: false
                    }
                },
                {
                    breakpoint: 830,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        centerMode: false
                    }
                },
                {
                    breakpoint: 1080,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        centerMode: false
                    }
                },
                {
                    breakpoint: 1585,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        centerMode: false
                    }
                },
            ]
        });
    }

    let hash = location.hash;

    // PORTAL RESOURCE SECTIONS
    $('.resource-section').hide();

    if(hash && $('.resource-section' + hash).length) {
        $("#resources_select").val(hash.substring(1))
        $('.resource-section' + hash).show();
        
    } else {
        $(".resource-section").first().show();
    }

    $(".resources_section #resources_select").change(function() {
        $('.resource-section').hide();
        $('.resource-section#' + $(this).val()).show();
    });

    $(".taxonomy-page #resources_select").change(function() {
        window.location.replace($(this).val())
    });

    
    //image popup
    // required elements
    var imgPopup = $('.img-popup');
    var imgCont = $('.rs_image');
    var popupImage = $('.img-popup img');
    var closeBtn = $('.close-btn');

    // handle events
    imgCont.on('click', function() {
        var img_src = $(this).children('img').attr('src');
        imgPopup.children('img').attr('src', img_src);
        imgPopup.addClass('opened');
    });

    $(imgPopup, closeBtn).on('click', function() {
        imgPopup.removeClass('opened');
        imgPopup.children('img').attr('src', '');
    });

    popupImage.on('click', function(e) {
        e.stopPropagation();
    });

    // END PORTAL RESOURCE SECTIONS

    //registraion form
    $(window).load(function () {
        //your code here
        let formHasBennFoundB4 = false;
        let mDone = false;
        let ghettoCounter = 0;
        const formComplete = function (event, jqXHR, ajaxOptions) {
            mDone = true;
            console.log("going off to pull data");
            fetch(window.location.origin + "/wp-json/wf_cr/v1/process_contractors_form_submissions")
        };
        let retry = () => {
            setTimeout(() => {
                let iframe = $(".hbspt-form iframe");
                if (iframe.length > 0) {
                    let form = iframe.contents().find("form");
                    if (form.length > 0) {
                        formHasBennFoundB4 = true;
                    } else {
                        if (formHasBennFoundB4) {
                            formComplete(null, null, null);
                        }
                    }
                } else {
                    if (formHasBennFoundB4) {
                        formComplete(null, null, null);
                    }
                }
                if (!mDone) {
                    ghettoCounter += 1;
                    // console.log("looping:" + ghettoCounter + ` formFound${formHasBennFoundB4}` + "\r");
                    retry();
                }
            }, 100)
        }
        retry();

        if(hash) {    
            let elem = $(hash)
            if(elem.length) {
                $("html, body").animate({ scrollTop: elem.offset().top - 120 });
            }
        }
    });
});

function mobileMenuSetup( menu, button, menuScreen ) { 
    jQuery( button + ', ' + menuScreen ).on( 'click', function() {

        // if not open, check for other open menus
        if(!jQuery(button).hasClass('open')) {
            jQuery('.menu-screen').hide()
            jQuery('.mobile-menu-button--collapse').removeClass('open')
            jQuery('.mobile-menu').hide()
        }


        jQuery( button ).stop().toggleClass( 'open' );
        jQuery( menu ).stop().slideToggle( 500 );
        jQuery( menuScreen ).stop().fadeToggle( 500 );
    } );

    jQuery( menu + ' .menu-item-has-children > a' ).on( 'click', function( e ) {
        e.preventDefault();
        jQuery( this ).parent().toggleClass( 'active' ).find( '.sub-menu' ).stop().slideToggle( 300 );
    } );
}

function handleFixedMenu() {
    const adminBar = jQuery('#wpadminbar')
    if(adminBar.length) {
        jQuery('#top__header').css('top', adminBar.outerHeight())
        jQuery('#header').css('top', adminBar.outerHeight() + jQuery('#top__header').outerHeight())
    }

    jQuery('#fixed-nav-pad').height(jQuery('#top__header').outerHeight() + jQuery('#header').outerHeight())
}